"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useFetch;
var _react = require("react");
var _qs = _interopRequireDefault(require("qs"));
var _isObjectEmpty = _interopRequireDefault(require("../utils/isObjectEmpty"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultOptions = {
  fetchOptions: {},
  onCompleted() {},
  onError() {}
};
function useFetch(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const {
    fetchOptions,
    params,
    body,
    onCompleted,
    onError,
    skip
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const [status, setStatus] = (0, _react.useState)(null);
  const [data, setData] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(null);
  const [loading, setLoading] = (0, _react.useState)(false);
  const abortController = (0, _react.useRef)(null);
  const signal = (0, _react.useMemo)(() => {
    var _abortController$curr;
    return (_abortController$curr = abortController.current) === null || _abortController$curr === void 0 ? void 0 : _abortController$curr.signal;
  }, [abortController]);
  (0, _react.useEffect)(() => {
    setLoading(!skip);
    setError(null);
    if (!skip) {
      let endpoint = url;
      let options = fetchOptions;
      if (!(0, _isObjectEmpty.default)(params)) endpoint += _qs.default.stringify(params, {
        addQueryPrefix: true
      });
      if (!(0, _isObjectEmpty.default)(body)) options.body = JSON.stringify(body);
      fetch(endpoint, _objectSpread(_objectSpread({}, fetchOptions), {}, {
        signal
      })).then(async res => {
        setStatus(res.status);
        if (res.status !== 200) {
          const data = await res.json();
          throw new Error(data === null || data === void 0 ? void 0 : data.message);
        }
        return res.json();
      }).then(data => {
        setData(data);
        setLoading(false);
        onCompleted(data);
      }).catch(error => {
        setError(error);
        setLoading(false);
        onError(error);
      });
    }
  }, [skip]);
  (0, _react.useEffect)(() => {
    abortController.current = new AbortController();
    return () => {
      var _abortController$curr2;
      (_abortController$curr2 = abortController.current) === null || _abortController$curr2 === void 0 || _abortController$curr2.abort();
    };
  }, []);
  return {
    status,
    error,
    data,
    loading
  };
}